import { useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import Button from "../../../../common/Button";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { ReactSVG } from "react-svg";
import { allergensEnum } from "./data";

const AllergensAlert = ({
  open = false,
  handleClose = () => { },
  confirmAction = () => { },
  onCross = () => { },
  className = ""
}) => {

  const [allergens, setAllergens] = useState([]);
  const resetState = () => {
  };

  useEffect(() => {
  }, [open]);

  const onClose = () => {
    handleClose();
    resetState();
  };

  const onConfirm = () => {
    confirmAction(allergens.includes("none") ? [] : allergens);
  };


  const multiSelection = (val) => {
    if (val === "none") {
      !allergens.includes(val)
        ? setAllergens(["none"])
        : setAllergens([]);
    } else {
      if (allergens.includes("none")) {
        setAllergens([val]);
      } else {
        allergens.includes(val)
          ? setAllergens(allergens.filter((item) => item !== val))
          : setAllergens([...allergens, val]);
      }
    }
  };

  return (
    <Transition
      enter="transition duration-300 ease-out"
      enterFrom="transform scale-100 opacity-0"
      enterTo="transform scale-100 opacity-100"
      leave="transition duration-300 ease-out"
      leaveFrom="transform scale-300 opacity-100"
      leaveTo="transform scale-100 opacity-0"
      className={"fixed z-[11]  top-0 left-0 w-full h-screen"}
      show={open}
    >
      <div
        className="fixed inset-0 bg-black/10 z-[1]"
        onClick={() => onClose()}
        aria-hidden="true"
      />
      <Transition.Child
        enter="transition duration-300 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-300 ease-out"
        leaveFrom="transform scale-300 opacity-100"
        leaveTo="transform scale-95 opacity-0"
        className={`bg-white z-[2] flex max-w-fit flex-col gap-6 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full rounded-s shadow-xl ${className}`}
      >
        <div className="flex flex-row justify-end rounded-s">
          <div className="px-4 pt-4 flex items-end">
            <button
              type="button"
              className="flex items-center justify-center p-[6px] transition-all rounded-full max-w-8 cursor-pointer right-4 top-3 bg-blue-200 hover:bg-REELTeal hover:text-white text-teal-300"
              onClick={() => onCross()}
            >
              <span className="sr-only">Close panel</span>
              <XMarkIcon
                className="w-5 h-5 m-auto"
                strokeWidth="2"
                aria-hidden="true"
              />
            </button>
          </div>
        </div>
        <div className="flex items-center justify-center mx-28 mb-4 h-[236px] w-[236px] bg-blue-100 rounded-full bg-opacity-40">
          <ReactSVG
            src={"/icons/review-allergens.svg"}
            className={``}
          />
        </div>
        <div className="px-8 h-[435px]">
          <h3
            className={`text-xl font-semibold pb-4`}
          >
            {"Review Symptoms & Allergens"}
          </h3>
          <p className={"text-gray-700"}>
            Did the allergy symptoms start with <b>exposure to an<br />allergen(s)?</b> Select all that apply
          </p>

          <div className="pt-4 grid grid-cols-12 gap-1">
            {allergensEnum.options.map((option) => {
              return (
                <div className={`col-span-6 flex flex-col`}>
                  <Button
                    className={`min-w-fit ${allergens?.includes(option.value)
                      ? "!bg-gray-50"
                      : "!bg-white"
                    }`}
                    type={"primary-outline"}
                    text={option.header}
                    onClick={() => {
                      multiSelection(option.value);
                    }}
                  />
                </div>
              );
            })}
          </div>
          <div
            className={`pt-4 grid gap-5 grid-cols-1`}
          >
            <Button
              type={"primary"}
              text={"Continue"}
              disabled={allergens.length === 0}
              onClick={() => {
                onConfirm();
              }}
            />
          </div>
        </div>
      </Transition.Child>
    </Transition>
  );
};

export default AllergensAlert;
